<template>
  <div class="results-view">
    <div class="container">
      <!-- 模型运行模块 -->
      <div class="card model-card">
        <div class="card-header">
          <i class="fas fa-cogs" style="font-size: 24px"></i>
          <h3 class="header-title">模型运行</h3>
        </div>
        <div class="card-body">
          <div class="model-controls">
            <!-- 情景选择 -->
            <div class="form-group">
              <select v-model="selectedModelScenario" class="form-select">
                <option value="baseline">碳中和情景</option>
                <option v-for="scenario in unrunScenarios" 
                        :key="scenario"
                        :value="scenario">
                  {{ scenario }}
                </option>
              </select>
            </div>
            
            <!-- 运行按钮 -->
            
            <button class="btn btn-primary" 
                    @click="runModel"
                    :disabled="!selectedModelScenario || isRunning">
              <i :class="['fas', isRunning ? 'fa-spinner fa-spin' : 'fa-play']"></i>
              {{ isRunning ? '运行中...' : '模型运行' }}
            </button>
          </div>

          <!-- 运行结果提示 -->
          <div class="result-message" v-if="showResult">
            <i class="fas fa-check-circle"></i>
            {{ selectedModelScenario === 'baseline' ? '碳中和情景' : selectedModelScenario }} 运行完成
          </div>
        </div>
      </div>

      <!-- 结果展示模块 -->
      <div class="card results-card">
        <div class="card-header">
          <i class="fas fa-chart-line"></i>
          <h3>结果展示</h3>
        </div>
        <div class="card-body">
          <!-- 筛选条件 -->
          <div class="filter-section">
            <!-- 情景选择 -->
            <div class="form-group scenario-group">
              <div class="input-group">
                <select v-model="scenarioToAdd" class="form-select">
                  <option value="">选择情景</option>
                  <option value="baseline" v-if="runScenarios.includes('baseline')">碳中和情景</option>
                  <option v-for="scenario in availableScenarios" 
                          :key="scenario"
                          :value="scenario">
                    {{ scenario }}
                  </option>
                </select>
                <button @click="addScenario" 
                        class="btn btn-primary"
                        :disabled="!canAddScenario">
                  <i class="fas fa-plus"></i>
                  <span style="font-size: 24px;">情景添加</span>
                </button>
              </div>
              <!-- 已选情景标签 -->
              <div class="selected-items">
                <div v-for="scenario in selectedScenarios" 
                     :key="scenario" 
                     class="item-tag">
                  <span class="tag-text">{{ scenario === 'baseline' ? '碳中和情景' : scenario }}</span>
                  <button class="remove-btn" @click="removeScenario(scenario)">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- 地域范围选择 -->
            <div class="form-group">
              <select v-model="selectedScope" 
                      class="form-select"
                      :disabled="!selectedScenarios.length">
                <option value="national">全国</option>
              </select>
            </div>

            <!-- 行业选择 -->
            <div class="form-group" v-if="selectedResultType !== 'perCapitaEnergy'">
              <select v-model="selectedIndustry" 
                      class="form-select">
                <option value="">选择行业</option>
                <option value="1">1农、林、牧、渔业</option>
                <option value="2">2煤炭开采和洗选业</option>
                <option value="3">3石油和天然气开采业</option>
                <option value="4">4黑色金属矿采选业</option>
                <option value="5">5有色金属矿采选业</option>
                <option value="6">6非金属矿采选业</option>
                <option value="7">7其他采矿业</option>
                <option value="8">8农副食品加工业</option>
                <option value="9">9食品制造业</option>
                <option value="10">10酒.饮料和精制茶制造业</option>
                <option value="11">11烟草制品业</option>
                <option value="12">12纺织业</option>
                <option value="13">13纺织服装.服饰业</option>
                <option value="14">14皮革.毛皮.羽毛及其制品和制鞋业</option>
                <option value="15">15木材加工和木.竹.藤.棕.草制品业</option>
                <option value="16">16家具制造业</option>
                <option value="17">17造纸和纸制品业</option>
                <option value="18">18印刷和记录媒介复制业</option>
                <option value="19">19文教.工美.体育和娱乐用品制造业</option>
                <option value="20">20石油.煤炭及其他燃料加工业</option>
                <option value="21">21化学原料和化学制品制造业</option>
                <option value="22">22医药制造业</option>
                <option value="23">23化学纤维制造业</option>
                <option value="24">24橡胶和塑料制品业</option>
                <option value="25">25非金属矿物制品业</option>
                <option value="26">26黑色金属冶炼和压延加工业</option>
                <option value="27">27有色金属冶炼和压延加工业</option>
                <option value="28">28金属制品业</option>
                <option value="29">29通用设备制造业</option>
                <option value="30">30专用设备制造业</option>
                <option value="31">31汽车制造业</option>
                <option value="32">32铁路.船舶.航空航天和其他运输设备制造业</option>
                <option value="33">33电气机械和器材制造业</option>
                <option value="34">34计算机.通信和其他电子设备制造业</option>
                <option value="35">35仪器仪表制造业</option>
                <option value="36">36其他制造业</option>
                <option value="37">37废弃资利用业</option>
                <option value="38">38金属制品.机械和设备修理业</option>
                <option value="39">39电力.热力生产和供应业</option>
                <option value="40">40燃气生产和供应业</option>
                <option value="41">41水的生产和供应业</option>
                <option value="42">42建筑业</option>
                <option value="43">43交通运输、仓储和邮政业</option>
                <option value="44">44批发和零售业、住宿和餐饮业</option>
                <option value="45">45其他行业</option>
                <option value="46">46城镇居民</option>
                <option value="47">47乡村居民</option>
              </select>
            </div>

            <!-- 添加结果变量选择 -->
            <div class="form-group">
              <select v-model="selectedResultType" 
                      class="form-select">
                <option value="finalEnergy">1. 终端用能结构</option>
                <option value="perCapitaEnergy">2. 人均能源消费量</option>
                <option value="elasticity">3. 能源消费弹性系数</option>
              </select>
            </div>
          </div>

          <!-- 未选择情景时的提示 -->
          <div class="empty-state" v-if="!runScenarios.length">
            <i class="fas fa-info-circle"></i>
            <p>请先运行模型以查看结果</p>
            <p class="sub-text">点击"模型运行"按钮运行所需情景</p>
          </div>

          <!-- 图表容器 -->
          <div v-else class="chart-wrapper">
            <div ref="chartRef" class="chart-container"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import PageHeader from '@/components/PageHeader.vue'
import * as echarts from 'echarts'
import axios from 'axios' // 导入axios用于API请求

export default {
  name: 'ResultsView',
  components: {
    PageHeader
  },
  setup() {
    const store = useStore()
    
    // 修改初始值
    const selectedModelScenario = ref('baseline')
    const isRunning = ref(false)
    const showResult = ref(false)
    const scenarioToAdd = ref('')
    const selectedScenarios = ref([])
    const selectedIndustry = ref('')
    const chartRef = ref(null)
    const chart = ref(null)
    const selectedResultType = ref('finalEnergy') // 新增：结果变量选择，默认为终端用能结构
    const serverBaseUrl = '' // 服务器基础URL，设置为空字符串以使用相对路径

    // 添加新的响应式变量
    const selectedScope = ref('national')  // 地域范围选择，默认为全国

    // 从 localStorage 获取已运行的情景列表
    const getStoredScenarios = () => {
      const stored = localStorage.getItem('runScenarios')
      return stored ? JSON.parse(stored) : []
    }

    // 已运行的场景列表
    const runScenarios = ref(getStoredScenarios())

    // 获取自定义情景列表
    const customScenarios = computed(() => {
      const scenarios = store.state.scenarios
      if (!scenarios) return []
      return Object.keys(scenarios).filter(s => s !== 'baseline')
    })

    // 未运行的情景列表
    const unrunScenarios = computed(() => {
      return customScenarios.value.filter(scenario => 
        !runScenarios.value.includes(scenario)
      )
    })

    // 可用的情景列表(已运行的)
    const availableScenarios = computed(() => {
      return customScenarios.value.filter(scenario => 
        runScenarios.value.includes(scenario)
      )
    })

    // 修改运行模型方法，确保加载状态至少显示2秒
    const runModel = async () => {
      if (!selectedModelScenario.value) return
      
      // 记录开始时间
      const startTime = Date.now()
      isRunning.value = true
      showResult.value = false
      
      try {
        // 调用后端API运行Python脚本
        const response = await axios.post(`${serverBaseUrl}/api/run-national-model`, {
          scenario: selectedModelScenario.value
        });
        
        console.log('API响应:', response.data);
        
        // 计算已经过的时间
        const elapsedTime = Date.now() - startTime
        const remainingTime = Math.max(0, 2000 - elapsedTime)
        
        // 确保加载状态至少显示2秒
        if (remainingTime > 0) {
          await new Promise(resolve => setTimeout(resolve, remainingTime))
        }
        
        // 检查响应是否成功
        if (response.data.success) {
          // 添加到已运行情景列表并保存到 localStorage
          if (!runScenarios.value.includes(selectedModelScenario.value)) {
            runScenarios.value.push(selectedModelScenario.value)
            localStorage.setItem('runScenarios', JSON.stringify(runScenarios.value))
          }
          
          showResult.value = true
        } else {
          // 显示错误信息
          console.error('模型运行失败:', response.data.error);
          alert(`模型运行失败: ${response.data.error}`);
        }
      } catch (error) {
        // 确保错误情况下也至少等待2秒
        const elapsedTime = Date.now() - startTime
        const remainingTime = Math.max(0, 2000 - elapsedTime)
        
        if (remainingTime > 0) {
          await new Promise(resolve => setTimeout(resolve, remainingTime))
        }
        
        console.error('API请求错误:', error);
        alert(`请求错误: ${error.message}。请确保后端服务器正在运行。`);
      } finally {
        isRunning.value = false
        
        // 如果显示了成功结果，几秒后隐藏
        if (showResult.value) {
          setTimeout(() => {
            showResult.value = false
          }, 3000)
        }
      }
    }

    // 获取图表数据
    const getChartData = () => {
      // 根据选择的结果类型返回不同的数据
      switch (selectedResultType.value) {
        case 'perCapitaEnergy':
          return processPerCapitaData()
        case 'elasticity':
          return processElasticityData()
        case 'finalEnergy':
        default:
          return processChartData(selectedScope.value, selectedIndustry.value)
      }
    }

    // 更新图表
    const updateChart = () => {
      if (!chart.value) {
        initChart()
        return
      }

      // 如果基本条件不满足，清空图表
      if (!selectedScenarios.value.length) {
        chart.value.clear()
        return
      }

      // 在更新图表前先清空现有配置
      chart.value.clear()

      // 根据选择的结果类型设置不同的图表配置
      let option
      
      // 获取处理后的数据
      if (selectedResultType.value === 'perCapitaEnergy') {
        const chartData = processPerCapitaData()
        option = getPerCapitaChartOption(chartData)
      } else if (selectedResultType.value === 'elasticity') {
        const chartData = processElasticityData()
        option = getElasticityChartOption(chartData)
      } else {
        // 终端用能结构 - 堆叠柱状图
        const chartData = processChartData(selectedScope.value, selectedIndustry.value)
        const years = chartData.map(d => d.year)
        const series = [
          {
            name: '电',
            type: 'bar',
            stack: 'total',
            emphasis: { focus: 'series' },
            data: chartData.map(d => d.electric),
            itemStyle: { color: '#91cc75' }
          },
          {
            name: '热力',
            type: 'bar',
            stack: 'total',
            emphasis: { focus: 'series' },
            data: chartData.map(d => d.heat),
            itemStyle: { color: '#fac858' }
          },
          {
            name: '氢',
            type: 'bar',
            stack: 'total',
            emphasis: { focus: 'series' },
            data: chartData.map(d => d.hydrogen),
            itemStyle: { color: '#5470c6' }
          },
          {
            name: '煤',
            type: 'bar',
            stack: 'total',
            emphasis: { focus: 'series' },
            data: chartData.map(d => d.coal),
            itemStyle: { color: '#333333' }
          },
          {
            name: '油',
            type: 'bar',
            stack: 'total',
            emphasis: { focus: 'series' },
            data: chartData.map(d => d.oil),
            itemStyle: { color: '#ee6666' }
          },
          {
            name: '气',
            type: 'bar',
            stack: 'total',
            emphasis: { focus: 'series' },
            data: chartData.map(d => d.gas),
            itemStyle: { color: '#73c0de' }
          },
          {
            name: '其他',
            type: 'bar',
            stack: 'total',
            emphasis: { focus: 'series' },
            data: chartData.map(d => d.other),
            itemStyle: { color: '#9a60b4' }
          }
        ]

        option = {
          title: {
            text: getChartTitle(),
            left: 'center',
            top: 20,
            textStyle: {
              fontSize: 24,
              fontWeight: 'bold',
              color: '#2d3748'
            }
          },
          tooltip: {
            trigger: 'axis',
            show: true,
            axisPointer: {
              type: 'shadow'
            },
            formatter: function(params) {
              let year = params[0].axisValue;
              let total = 0;
              let result = `<div style="font-size:16px;font-weight:bold;margin-bottom:8px">${year}年</div>`;
              
              params.forEach(param => {
                if (param.value > 0) {
                  total += param.value;
                  result += `
                    <div style="display:flex;justify-content:space-between;margin:4px 0">
                      <span>${param.seriesName}:</span>
                      <span style="margin-left:15px;font-weight:bold">
                        ${param.value.toFixed(1)}万吨标准煤
                      </span>
                    </div>`;
                }
              });
              
              result += `
                <div style="margin-top:8px;padding-top:8px;border-top:1px solid #eee">
                  <span>总计:</span>
                  <span style="margin-left:15px;font-weight:bold">
                    ${total.toFixed(1)}万吨标准煤
                  </span>
                </div>`;
              
              return result;
            }
          },
          legend: {
            bottom: 10,
            left: 'center',
            itemWidth: 25,
            itemHeight: 14,
            textStyle: {
              fontSize: 24,
              color: '#4a5568',
              itemGap: 25
            },
          },
          grid: {
            left: '10%',
            right: '5%',
            bottom: '15%',
            top: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: years,
            axisLabel: {
              fontSize: 20,
              interval: 0,
              color: '#4a5568'
            },
            axisLine: {
              lineStyle: {
                color: '#e2e8f0'
              }
            }
          },
          yAxis: {
            type: 'value',
            name: '（万吨标准煤）',
            nameLocation: 'end',
            nameGap: 15,
            nameTextStyle: {
              fontSize: 22,
              color: '#4a5568',
              align: 'right',
              padding: [5, 0, 0, 0]
            },
            axisLabel: {
              fontSize: 20,
              color: '#4a5568',
              formatter: value => value.toFixed(1)
            },
            splitLine: {
              lineStyle: {
                color: '#e2e8f0',
                type: 'dashed'
              }
            }
          },
          series: series.map(s => ({
            ...s,
            barWidth: '60%',
            label: {
              show: false,
              position: 'inside',
              fontSize: 18,
              color: '#fff',
              formatter: function(params) {
                if (params.value > 0) {
                  return ''
                }
                return ''
              }
            },
            emphasis: {
              focus: 'series',
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.2)'
              }
            }
          }))
        }
      }

      chart.value.setOption(option, true)
    }

    // 人均能源消费量图表配置
    const getPerCapitaChartOption = (chartData) => {
      return {
        title: {
          text: '全国人均能源消费量',  // 明确标题为全国数据
          left: 'center',
          top: 20,
          textStyle: {
            fontSize: 24,
            fontWeight: 'bold',
            color: '#2d3748'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            return `${params[0].axisValue}年: ${params[0].value.toFixed(3)} 吨标准煤/人`;
          }
        },
        grid: {
          left: '10%',
          right: '5%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: chartData.map(d => d.year),
          axisLabel: {
            fontSize: 20,
            interval: 0,
            color: '#4a5568'
          }
        },
        yAxis: {
          type: 'value',
          name: '（吨标准煤/人）',
          nameLocation: 'end',
          nameGap: 15,
          nameTextStyle: {
            fontSize: 22,
            color: '#4a5568',
            align: 'right'
          },
          axisLabel: {
            fontSize: 20,
            color: '#4a5568',
            formatter: value => value.toFixed(3)
          }
        },
        series: [{
          name: '人均能源消费量',
          data: chartData.map(d => d.value),
          type: 'bar',
          barWidth: '40%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#83bff6' },
              { offset: 0.5, color: '#188df0' },
              { offset: 1, color: '#188df0' }
            ])
          },
          emphasis: {
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2378f7' },
                { offset: 0.7, color: '#2378f7' },
                { offset: 1, color: '#83bff6' }
              ])
            }
          }
        }]
      }
    }

    // 能源消费弹性系数图表配置
    const getElasticityChartOption = (chartData) => {
      // 找出数据中的最大值和最小值用于调整Y轴
      let minVal = Math.min(...chartData.map(d => d.value))
      let maxVal = Math.max(...chartData.map(d => d.value))
      
      // 为了更好的显示效果，调整最小值和最大值
      minVal = Math.min(minVal, -1) // 确保至少有负值显示
      maxVal = Math.max(maxVal, 1)  // 确保至少有正值显示
      
      // 为图表添加一些边距
      const valueMargin = Math.max(0.5, (maxVal - minVal) * 0.1)
      
      return {
        title: {
          text: selectedIndustry.value ? `${document.querySelector(`option[value="${selectedIndustry.value}"]`)?.textContent || selectedIndustry.value}：能源消费弹性系数` : '全国能源消费弹性系数',
          left: 'center',
          top: 20,
          textStyle: {
            fontSize: 24,
            fontWeight: 'bold',
            color: '#2d3748'
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            return `${params[0].axisValue}年: ${params[0].value.toFixed(3)}`;
          }
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: ['弹性系数'],
          textStyle: {
            fontSize: 24,
            color: '#4a5568'
          }
        },
        grid: {
          left: '10%',
          right: '5%',
          bottom: '15%',
          top: '15%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: chartData.map(d => d.year),
          axisLabel: {
            fontSize: 20,
            interval: 0,
            color: '#4a5568'
          }
        },
        yAxis: {
          type: 'value',
          name: '弹性系数',
          nameLocation: 'end',
          nameGap: 15,
          min: minVal - valueMargin,
          max: maxVal + valueMargin,
          nameTextStyle: {
            fontSize: 22,
            color: '#4a5568',
            align: 'right'
          },
          axisLabel: {
            fontSize: 20,
            color: '#4a5568',
            formatter: value => value.toFixed(2)
          },
          splitLine: {
            lineStyle: {
              color: '#e2e8f0',
              type: 'dashed'
            }
          }
        },
        series: [{
          name: '弹性系数',
          type: 'line',
          smooth: true,
          data: chartData.map(d => d.value),
          symbolSize: 10,
          lineStyle: {
            width: 4,
            color: '#5470c6'
          },
          itemStyle: {
            color: '#5470c6'
          },
          markLine: {
            silent: true,
            lineStyle: {
              color: '#333',
              type: 'dashed',
              width: 1
            },
            data: [{
              yAxis: 0,
              label: {
                position: 'start',
                formatter: '零线',
                fontSize: 16
              }
            }]
          }
        }]
      }
    }

    // 获取图表标题
    const getChartTitle = () => {
      if (selectedIndustry.value) {
        const industryLabel = document.querySelector(`option[value="${selectedIndustry.value}"]`)?.textContent || selectedIndustry.value
        return `${industryLabel}：燃料构成`
      } else {
        return `全国：燃料构成`
      }
    }

    // 判断地域选择是否有效
    const isValidScope = computed(() => {
      return true  // 始终有效，因为只有一个选项：全国
    })

    // 处理人均能源消费量数据
    const processPerCapitaData = () => {
      const nationalData = require('@/data/national_output_data.json')
      const years = ['2025', '2030', '2035', '2040', '2045', '2050', '2055', '2060'] // 不包括2020年
      
      return years.map(year => {
        return {
          year,
          value: nationalData.CN60.Per_Capita_Energy?.[year] || 0
        }
      })
    }

    // 处理能源消费弹性系数数据
    const processElasticityData = () => {
      const nationalData = require('@/data/national_output_data.json')
      const years = ['2025', '2030', '2035', '2040', '2045', '2050', '2055', '2060'] // 不包括2020年
      
      if (selectedIndustry.value) {
        // 特定行业的弹性系数
        const sectorKey = `sector${selectedIndustry.value}`
        const sectorData = nationalData.CN60[sectorKey]?.Elastic || {}
        
        return years.map(year => {
          return {
            year,
            value: sectorData[year] || 0
          }
        })
      } else {
        // 如果没有选择行业，计算平均弹性系数
        // 注意：我们这里直接返回每个行业的平均值，不混合其他数据
        let sectorCount = 0
        const totalElastic = years.reduce((result, year) => {
          result[year] = 0
          return result
        }, {})
        
        // 累加所有行业的弹性系数
        Object.keys(nationalData.CN60).forEach(key => {
          if (key.startsWith('sector') && nationalData.CN60[key].Elastic) {
            sectorCount++
            years.forEach(year => {
              totalElastic[year] += (nationalData.CN60[key].Elastic[year] || 0)
            })
          }
        })
        
        // 计算平均值
        return years.map(year => {
          return {
            year,
            value: sectorCount > 0 ? totalElastic[year] / sectorCount : 0
          }
        })
      }
    }

    // 监听变化
    watch(
      [
        selectedScenarios,
        selectedIndustry,
        selectedResultType  // 添加对结果类型选择的监听
      ],
      () => {
        if (selectedScenarios.value.length > 0) {
          nextTick(() => {
            updateChart()
          })
        }
      },
      { deep: true, immediate: true }
    )

    // 监听结果类型变化，如果选择人均能源消费，则清除行业选择
    watch(
      selectedResultType,
      (newValue) => {
        if (newValue === 'perCapitaEnergy') {
          // 人均能源消费时清除行业选择
          selectedIndustry.value = ''
        }
      }
    )

    // 组件挂载时初始化图表
    onMounted(() => {
      // 确保 DOM 已经渲染
      nextTick(() => {
        initChart()
      })
    })

    // 添加初始化函数
    const initChart = () => {
      if (!chartRef.value) return
      
      // 如果已经有实例，先销毁
      if (chart.value) {
        chart.value.dispose()
      }
      
      // 创建新实例
      chart.value = echarts.init(chartRef.value)
      
      // 如果有数据，立即更新
      if (selectedScenarios.value.length && selectedIndustry.value) {
        updateChart()
      }
      
      // 添加resize监听
      window.addEventListener('resize', () => {
        chart.value?.resize()
      })
    }

    // 判断是否可以添加情景
    const canAddScenario = computed(() => {
      return scenarioToAdd.value && !selectedScenarios.value.includes(scenarioToAdd.value)
    })
    
    // 添加情景
    function addScenario() {
      if (canAddScenario.value) {
        selectedScenarios.value.push(scenarioToAdd.value)
        scenarioToAdd.value = ''
        updateChart()
      }
    }
    
    // 移除情景
    function removeScenario(scenario) {
      selectedScenarios.value = selectedScenarios.value.filter(s => s !== scenario)
      updateChart()
    }

    // 在 setup() 中添加数据处理函数
    const processChartData = (scope, industry) => {
      const nationalData = require('@/data/national_output_data.json')
      const years = ['2020', '2025', '2030', '2035', '2040', '2045', '2050', '2055', '2060']
      
      // 处理全国数据和行业数据
      return years.map(year => {
        const yearData = {
          year,
          electric: 0,
          heat: 0,
          hydrogen: 0,
          coal: 0,
          oil: 0,
          gas: 0,
          other: 0,
          total: 0
        }
        
        // 根据选择的行业获取数据
        if (industry) {
          const sectorKey = `sector${industry}`
          const sectorData = nationalData.CN60[sectorKey]?.Final_Energy
          if (sectorData) {
            yearData.electric = sectorData.Electricity?.[year] || 0
            yearData.heat = sectorData.Heat?.[year] || 0
            yearData.hydrogen = sectorData.Hydrogen?.[year] || 0
            yearData.coal = sectorData.Coal?.[year] || 0
            yearData.oil = sectorData.Oil?.[year] || 0
            yearData.gas = sectorData.Natural_Gas?.[year] || 0
            yearData.other = sectorData.Other_Energy?.[year] || 0
            yearData.total = yearData.electric + yearData.heat + yearData.hydrogen + yearData.coal + yearData.oil + yearData.gas + yearData.other
          }
        } else {
          // 如果没有选择行业，返回全国总数据
          Object.keys(nationalData.CN60).forEach(sectorKey => {
            if (sectorKey.startsWith('sector')) {
              const sectorData = nationalData.CN60[sectorKey]?.Final_Energy
              if (sectorData) {
                yearData.electric += sectorData.Electricity?.[year] || 0
                yearData.heat += sectorData.Heat?.[year] || 0
                yearData.hydrogen += sectorData.Hydrogen?.[year] || 0
                yearData.coal += sectorData.Coal?.[year] || 0
                yearData.oil += sectorData.Oil?.[year] || 0
                yearData.gas += sectorData.Natural_Gas?.[year] || 0
                yearData.other += sectorData.Other_Energy?.[year] || 0
              }
            }
          })
          yearData.total = yearData.electric + yearData.heat + yearData.hydrogen + yearData.coal + yearData.oil + yearData.gas + yearData.other
        }
        
        return yearData
      })
    }

    return {
      selectedModelScenario,
      isRunning,
      showResult,
      scenarioToAdd,
      selectedScenarios,
      selectedIndustry,
      customScenarios,
      runScenarios,
      runModel,
      chartRef,
      unrunScenarios,
      availableScenarios,
      canAddScenario,
      addScenario,
      removeScenario,
      selectedScope,
      isValidScope,
      selectedResultType  // 返回新的状态变量
    }
  }
}
</script>

<style scoped>
.results-view {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  animation: fadeIn 0.6s ease-out;
}

/* 卡片基础样式 */
.card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background: linear-gradient(to right, #f8f9fa, #ffffff);
  border-bottom: 1px solid #eef2f7;
}

.card-header i {
  font-size: 32px;
  color: #1890ff;
}

.card-header h3 {
  font-size: 28px;
  color: #2d3748;
  font-weight: 600;
  margin: 0;
}

.card-body {
  padding: 30px;
}

/* 模型运行模块样式 */
.model-controls {
  display: flex;
  gap: 16px;
  align-items: flex-end;
}

.form-group {
  flex: 1;
}

.form-group label {
  display: block;
  margin-bottom: 10px;
  font-size: 20px;
  font-weight: 500;
  color: #1e4c6b;
}

/* 表单元素样式 */
.form-select {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 22px;
  color: #4a5568;
  background-color: white;
  transition: all 0.2s ease;
}

.form-select:hover {
  border-color: #40a9ff;
}

.form-select:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* 按钮样式 */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 24px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  height: 52px;
}

.btn i {
  font-size: 22px;
}

.btn-primary {
  background: linear-gradient(135deg, #1890ff, #096dd9);
  color: white;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #40a9ff, #1890ff);
  transform: translateY(-1px);
}

.btn-primary:disabled {
  background: linear-gradient(135deg, #d9d9d9, #bfbfbf);
  cursor: not-allowed;
  transform: none;
}

/* 结果提示 */
.result-message {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
  padding: 12px;
  background: #f6ffed;
  border-radius: 8px;
  color: #52c41a;
  font-size: 20px;
  animation: fadeIn 0.3s ease-out;
}

.result-message i {
  font-size: 22px;
}

/* 图表控件 */
.chart-controls {
  display: flex;
  gap: 12px;
  margin-left: auto;
}

.chart-controls .form-select {
  width: 150px;
}

/* 图表容器 */
.chart-container {
  height: 600px;
  min-height: 500px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  padding: 20px;
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .container {
    padding: 15px;
  }
  
  .model-controls {
    flex-direction: column;
    gap: 12px;
  }
  
  .chart-controls {
    flex-direction: column;
    margin-left: 0;
    margin-top: 12px;
  }
  
  .chart-container {
    height: 400px;
  }
}

/* 筛选区域样式 */
.filter-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
  margin-bottom: 30px;
}

/* 情景选择组样式 */
.scenario-group {
  grid-column: span 2;
}

/* 空状态提示 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  color: #8c8c8c;
  text-align: center;
  background: #fafafa;
  border-radius: 12px;
  margin-top: 20px;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 16px;
  color: #d9d9d9;
}

.empty-state p {
  margin: 0;
  font-size: 20px;
}

.empty-state .sub-text {
  font-size: 18px;
  color: #bfbfbf;
  margin-top: 8px;
}

/* 图表包装器 */
.chart-wrapper {
  margin-top: 25px;
  padding: 0;
  background: transparent;
  box-shadow: none;
}

/* 添加运行状态动画 */
.model-card {
  position: relative;
}

.model-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #1890ff, #096dd9);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.model-card.is-running::after {
  transform: scaleX(1);
}

.result-message {
  transform: translateY(0);
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.result-message.hide {
  transform: translateY(-10px);
  opacity: 0;
}

/* 优化图表容器样式 */
.chart-wrapper {
  position: relative;
  transition: all 0.3s ease;
}

.chart-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.chart-wrapper:hover::before {
  opacity: 1;
}

.form-select[multiple] {
  height: auto;
  min-height: 120px;
}

/* 已选情景标签样式 */
.selected-items {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
  min-height: 50px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 8px;
}

.item-tag {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  background: white;
  border: 1px solid #e6f7ff;
  border-radius: 6px;
  font-size: 20px;
  color: #1890ff;
  box-shadow: 0 2px 6px rgba(24, 144, 255, 0.1);
  animation: fadeIn 0.3s ease-out;
  transition: all 0.3s ease;
}

.item-tag:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15);
}

.tag-text {
  margin-right: 8px;
}

.remove-btn {
  background: none;
  border: none;
  padding: 2px 6px;
  color: #999;
  cursor: pointer;
  transition: color 0.3s;
  border-radius: 4px;
}

.remove-btn:hover {
  color: #ff4d4f;
  background: rgba(255, 77, 79, 0.1);
}

/* 响应式设计调整 */
@media (max-width: 768px) {
  .filter-section {
    grid-template-columns: 1fr;
  }
  
  .scenario-group {
    grid-column: span 1;
  }
}

/* 情景选择输入组样式 */
.input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}

.input-group .form-select {
  flex: 1;
}

.input-group .btn {
  flex-shrink: 0;
  min-width: 100px;
}

/* 优化添加按钮样式 */
.input-group .btn-primary {
  height: 48px; /* 调整为与模型运行按钮一致的高度 */
  padding: 0 20px;
  border-radius: 8px;
  font-size: 24px; /* 调整为与模型运行按钮一致的字体大小 */
}

.header-title {
  font-size: 54px;
  margin: 0;
  font-weight: 600;
  color: #2d3748;
}
</style>
